import { LoginFormContainer } from './components/LoginFormContainer';
import { AuthPageBody } from '../../components/AuthPageBody/AuthPageBody';

export const Login = (): JSX.Element => {
  return (
    <AuthPageBody>
      <LoginFormContainer />
    </AuthPageBody>
  );
};
